/**
 * useDebounce - debounce a value by a given delay.
 * Useful for search inputs to avoid excessive API calls.
 */
import { useEffect, useState } from "react";

/**
 * Returns a debounced version of the provided value.
 * Updates only after the specified delay of inactivity.
 *
 * @param value  The value to debounce
 * @param delay  Debounce delay in milliseconds (default: 300)
 */
export function useDebounce<T>(value: T, delay = 300): T {
  const [debounced, setDebounced] = useState<T>(value);

  useEffect(() => {
    const timer = setTimeout(() => setDebounced(value), delay);
    return () => clearTimeout(timer);
  }, [value, delay]);

  return debounced;
}
